import React from 'react';
import { Link } from 'react-router-dom';

const FreeTrialPromo = () => {
  return (
    <div className="container mx-auto">
      {/* Flex container for text and image */}
      <div className="flex flex-col md:flex-row md:items-center md:gap-8 mb-6">
        {/* Left content: Title and text */}
        <div className="md:w-1/2 mb-0">
          <h2 className='text-2xl md:text-3xl font-bold mb-4'>Noch nicht überzeugt?</h2>
          <p className='text-lg'>Dann melde dich doch einfach zu unserer wöchentlichen kostenlosen Probestunde an! Jeden Mittwoch um 17 Uhr.</p>
        </div>
        
        {/* Right content: Image */}
        <div className="md:w-1/2">
          <div className="flex justify-center">
            <img
              src="./codekids/codekid2_happy.svg"
              alt="Kind programmiert"
              className="w-3/4 my-0"
            />
          </div>
        </div>
      </div>
      
      {/* Button container - always centered and below */}
      <div className="flex justify-center mt-4">
        <Link
          to="/start/signup"
          className="inline-block px-8 py-3 bg-custom_primary text-white text-xl font-semibold no-underline rounded-full shadow-md hover:bg-custom_primary/80 hover:text-black transition-colors duration-300"
        >
          Anmelden!
        </Link>
      </div>
    </div>
  );
};

export default FreeTrialPromo;